import React from "react";
import { Tag, Space, Popconfirm, Button } from "antd";
import { MdDelete, MdEdit } from "react-icons/md";
import moment from "moment";

export const columns = ({
  handleEditAnnouncement,
  handleDeleteAnnouncement,
  loaders,
  role,
}) => [
  {
    title: "Title",
    dataIndex: "title",
    key: "title",
    render: (text) => <span style={{ color: "#1890ff", cursor: "pointer" }}>{text}</span>,
  },
  {
    title: "Body",
    dataIndex: "body",
    key: "body",
    render: (text) => (
      <div style={{ maxWidth: 200, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
        {text}
      </div>
    ),
  },
  {
    title: "Start Date",
    dataIndex: "start_date",
    key: "start_date",
    render: (date) => moment(date).format("YYYY-MM-DD"),
  },
  {
    title: "End Date",
    dataIndex: "end_date",
    key: "end_date",
    render: (date) => moment(date).format("YYYY-MM-DD"),
  },
  {
    title: "Status",
    dataIndex: "is_active",
    key: "is_active",
    render: (active) => (
      <Tag color={active ? "green" : "volcano"}>
        {active ? "ACTIVE" : "INACTIVE"}
      </Tag>
    ),
  },
  {
    title: "Action",
    key: "action",
    hidden: role !== "admin",
    render: (text, record) => (
      <Space size="middle">
        <Button
          type="primary"
          icon={<MdEdit />}
          onClick={() => handleEditAnnouncement(record)}
        >
          Edit
        </Button>
        <Popconfirm
          title="Are you sure to delete this announcement?"
          onConfirm={() => handleDeleteAnnouncement(record.id)}
          okText="Yes"
          cancelText="No"
        >
          <Button
            type="danger"
            icon={<MdDelete />}
            loading={loaders.includes(record.id)}
          >
            Delete
          </Button>
        </Popconfirm>
      </Space>
    ),
  },
].filter((column) => !column.hidden);
